/* @flow */

import type { RootState, Settings } from '../types'

export const STATE_KEY: string = 'currentSettings'

type SetCurrentSettingsAction = {
  type: 'opinary/SET_CURRENT_SETTINGS',
  settings: Settings,
}

export function setCurrentSettings(
  settings: Settings
): SetCurrentSettingsAction {
  return {
    type: 'opinary/SET_CURRENT_SETTINGS',
    settings,
  }
}

type UnsetCurrentSettingsAction = {
  type: 'opinary/UNSET_CURRENT_SETTINGS',
}

export function unsetCurrentSettings(): UnsetCurrentSettingsAction {
  return {
    type: 'opinary/UNSET_CURRENT_SETTINGS',
  }
}

export function selectCurrentSettings(rootState: RootState): ?Settings {
  return rootState[STATE_KEY]
}

export default function reducer(
  state: ?Settings = null,
  action: SetCurrentSettingsAction | UnsetCurrentSettingsAction
): ?Settings {
  switch (action.type) {
    case 'opinary/SET_CURRENT_SETTINGS':
      return action.settings
    case 'opinary/UNSET_CURRENT_SETTINGS':
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/currentSettings.js